module.exports = __webpack_public_path__ + "static/dl1-banner2-04ae8a5ab65905c76d557eca737afd70.jpg";